var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RoleForm',{key:((_vm.reg.id) + "_"),attrs:{"content":_vm.reg}}),_c('h4',[_vm._v("LISTA DE PERMISOS")]),_c('RolePermissions',{key:_vm.id,attrs:{"roleId":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }